import { render, staticRenderFns } from "./ManageCategoryCustomers.vue?vue&type=template&id=52992ae6&scoped=true"
import script from "./ManageCategoryCustomers.vue?vue&type=script&lang=js"
export * from "./ManageCategoryCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52992ae6",
  null
  
)

export default component.exports